<!-- <div class="card flex justify-content-center gap-2">
  <p-button
    type="button"
    (onClick)="
      customToast({ severity: 'error', summary: 'Error', detail: 'Test toast' })
    "
    label="Success"
    severity="success"
  />
</div> -->
<p-toast />
